module.exports = require('./helpers/bundle-url').getBundleURL('la5Oi') + "logo-dark.ba5147f0.svg";